module.exports = __webpack_public_path__ + "img/stock0.03ed4d79.png";